<template>
    <div class="setUserReward">
        <el-dialog :visible="isShowReward" width="70%" @close="handleClose">
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                    <span
                        style="font-weight:700;font-size:13px"
                    >"{{publickData.brandName}}终端类型"的平台奖励</span>
                </div>
                <el-form ref="form" :label-position="'left'" :model="userRewardForm">
                    <el-tabs v-model="activeName">
                        <!-- Tab页 -->
                        <!-- v-for="(tabItem,tabIndex) in tabContent" -->
                        <el-tab-pane label="平台奖励" name="platform">
                            <template v-for="(titleItem,titleIndex) in tabContent">
                                <!-- 小标题 -->
                                <div :key="titleIndex">
                                    <div class="type_title">{{titleItem.title}}</div>
                                    <el-form-item
                                        v-for="(item,index) in titleItem.list"
                                        :label="item.title"
                                        :key="index"
                                        v-if="titleItem.type != 6"
                                    >
                                        <el-input
                                            v-model="item.value"
                                            size="medium"
                                            :placeholder="isEdit ==1? item.sub_title : ''"
                                            :disabled="isEdit != 1 || item.is_edit != 1"
                                        ></el-input>
                                    </el-form-item>
                                    
                                    <el-form-item
                                        v-for="(item,index) in titleItem.list"
                                        :label="item.flow_card_step_name"
                                        :key="index"
                                        v-if="titleItem.type == 6"
                                    >
                                        <el-table :data="item.list" size="mini" border style="width: 100%">
                                            <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="channel_name"
                                                label="扣款时间"
                                                min-width="90"
                                            >
                                            <template slot-scope="scope">
                                                {{scope.row.days}}个月
                                              
                                            </template>
                                            </el-table-column>
                                            <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="target_money"
                                                label="流量卡金额"
                                                min-width="90"
                                            ></el-table-column>
                                            <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="reward_money"
                                                label="可返现金额"
                                                min-width="90"
                                            ></el-table-column>
                                            <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="value"
                                                label="下级返现金额"
                                                min-width="150"
                                            >
                                            <template slot-scope="scope">
                                                <el-input
                                                    v-model="scope.row.value"
                                                    size="medium"
                                                    :placeholder="isEdit ==1? scope.row.sub_title : ''"
                                                    :disabled="isEdit != 1 || scope.row.is_edit != 1"
                                                >
                                                <template slot="suffix">
                                                    <span style = "line-height: 40px;width: 40px;align-items: c;">元</span>
                                                </template>
                                                </el-input>
                                              
                                            </template>
                                            
                                            </el-table-column>
                                                
                                        </el-table>
                                    
                                    
                                        
                                    </el-form-item>
                                    
                                    
                                    <div class="endTime">活动最终截止日期：{{titleItem.cut_off_time}}</div>
                                    <el-divider></el-divider>
                                </div>
                            </template>
                            <el-button
                                @click="handleSubmit(tabContent,1)"
                                type="primary"
                                style="font-size:12px"
                                :disabled="isEdit != 1"
                                v-if="level == 0 || (isEdit == 1 && canSet == true)"
                            >提 交</el-button>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="个人奖励" name="personal">
                            <template v-for="(titleItem,titleIndex) in personalForm.data">
                                <div :key="titleIndex" v-if="!titleItem.title.includes('流量卡返现奖励')">
                                    <div class="type_title">{{titleItem.title}}</div>
                                    <div v-for="(v,i)  in titleItem.setting" :key="i">
                                        <el-form-item
                                            v-for="(item,index) in v.list"
                                            :label="item.title"
                                            :key="index"
                                        >
                                            <el-input
                                                v-model="item.value"
                                                size="medium"
                                                :placeholder="isEdit ==1? item.sub_title : ''"
                                                :disabled="item.is_edit == 0"
                                            ></el-input>
                                            <div class="endTime">{{item.sub_title}}</div>
                                        </el-form-item>
                                    </div>
                                    <div class="endTime">活动最终截止日期：{{titleItem.cut_off_time}}</div>
                                    <el-divider></el-divider>
                                </div>
                            </template>
                        </el-tab-pane> -->
                    </el-tabs>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "UM_setUserReward",
    props: {
        isShowReward: {
            type: Boolean,
            default: false
        },
        publickData: {
            type: Object
        },
        canSet: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeName: 'platform', //platform平台 personal个人
            tabContent: [],
            userRewardForm: {
                user: ''
            },
            cloneData: [],
            isEdit: null,
            personalForm: {
                data: []
            },
            level: sessionStorage.getItem('level'),
            isAdd:null,  //0 未提交数据 1首次提交数据 
        }
    },
    created() {
        let { brandId, userId } = this.publickData;
        this.getPlatform({ brand_id: brandId, ally_user_id: userId });
        // this.getPersonal({ brand_id: brandId, ally_user_id: userId });
    },
    mounted() {
    },
    methods: {
        handleSubmit(val, reward_type) {
            let { brandId, userId } = this.publickData;
            let cloneDatas = this._.mapKeys(this.cloneData, (value) => {
                return value.reward_type;
            });
            let dataSource = cloneDatas[reward_type]; //平台奖励 or other
            let reqList = []; //请求的list
            let reqData = { //请求的数据
                brand_id: brandId,
                ally_user_id: userId,
                is_add : this.isAdd,
            };
            this._.forEach(val, (v, i) => {
                let dataVal = dataSource.list[i];
                if (v.type == 6) {
                    this._.forEach(v.list, (model, index) => {
                        let modelDataNew = dataVal.list[index];
                        this._.forEach(model.list,(item,index)=>{
                            let dataNew = modelDataNew.list[index]
                            if (item.value != '') {
                                if (dataNew.value !== item.value) { //不一致等于修改过
                                    reqList.push(this._.pick(item, ['brand_reward_conf_id', 'value','type','channel','target_money','user_reward_id']));
                                }
                            }
                            
                        })
                        
                    })
                    
                }else {
                    this._.forEach(v.list, (item, index) => {
                        let dataNew = dataVal.list[index];
                        if (item.value != '') {
                            if (dataNew.value !== item.value) { //不一致等于修改过
                                reqList.push(this._.pick(item, ['brand_reward_conf_id', 'value','type']));
                            }
                        }
                    })
                    
                }
                
            });
			console.log(reqList)
            if (!this._.isEmpty(reqList)) { //判断是否为空数组,如为空则不传data
                reqData.data = JSON.stringify(reqList);
            }
            this.$api.post('user_reward/user_reward_update', reqData, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    let { brandId, userId } = this.publickData;
                    this.getPlatform({ brand_id: brandId, ally_user_id: userId });
                    // this.getPersonal({ brand_id: brandId, ally_user_id: userId });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 5000
                    })
                }
            })
        },
        handleClose() {
            this.$emit('rewardClose');
        },
        getPlatform(params) { //获取平台奖励
            this.$api.post('user_reward/user_reward_list', params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.tabContent = data.list[0].list;
                    this.isEdit = data.is_edit;
                    this.isAdd = data.is_add;
                    this.cloneData = this._.cloneDeep(data.list); //存储原始值
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // getPersonal(params) { //获取个人奖励
        //     this.$api.post('user_reward/user_reward_subsidy_list', params, res => {
        //         if (res.code == 0) {
        //             let data = res.data;
        //             this.personalForm.data = data;
        //         } else {
        //             this.$message.error(res.msg);
        //         }
        //     })
        // }
    }
}
</script>

<style scoped lang="scss">
.setUserReward {
    ::v-deep .el-form-item__label {
        font-size: 12px;
        font-weight: 700;
    }
    ::v-deep .el-dialog {
        height: 80%;
        .el-dialog__body {
            height: 82%;
            overflow: auto;
        }
    }
    .endTime {
        font-size: 12px;
        color: #aaaaaa;
    }
    .el-input {
        width: auto;
    }
    ::v-deep .el-input__inner {
        width: 200px;
    }

    .type_title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
    }
}
</style>
